import { graphql } from '@apollo/react-hoc';
import { capitalize } from 'lodash';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import Container from 'components/Container';
import ContainerHeader from 'components/ContainerHeader';
import { HelpModals } from 'components/HelpModals';
import { Table } from 'components/Table';
import Text from 'components/Text';
import { EventHeader } from '../../Events/EventsMenu/components/EventHeader.js';
import { Column } from '../../Events/Header/StyledHeader';
import { query } from '../gql/queries/get-list';
import TextListExport from './TextListExport';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: start;
  max-width: 80vw;
`;

const GetList = ({ data, loading, error }) => {
  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const { id } = useParams(); // <- Add this back

  const location = useLocation();
  const { event } = location.state || {};

  useEffect(() => {
    if (data?.getList) {
      const list = data.getList;

      // Generate columns dynamically from the first recipient's data
      if (list.recipients && list.recipients.length > 0) {
        const firstRecipient = list.recipients[0];

        // Start with fixed columns
        const dynamicColumns = [
          {
            label: 'ID',
            key: 'id',
          },
          {
            label: 'Cellphone',
            key: 'cellphone',
          },
        ];

        // Add dynamic columns from data array
        if (firstRecipient.data && firstRecipient.data.length > 0) {
          firstRecipient.data.forEach((dataItem) => {
            dynamicColumns.push({
              label: capitalize(dataItem.key),
              key: dataItem.key,
            });
          });
        }

        setColumns(dynamicColumns);

        // Transform recipients data for the table
        const transformedData = list.recipients.map((recipient) => {
          const row = {
            id: recipient.id,
            cellphone: recipient.cellphone,
          };

          // Add dynamic data fields to the row
          if (recipient.data) {
            recipient.data.forEach((dataItem) => {
              row[dataItem.key] = dataItem.value;
            });
          }

          return row;
        });

        setTableData(transformedData);
      }
    }
  }, [data]);

  function renderRows(row) {
    return row;
  }

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!data?.getList) return <div>No data found</div>;

  return (
    <>
      <div
        style={{
          justifyContent: 'space-between',
          display: 'flex',
          paddingTop: 20,
          paddingRight: 40,
        }}
      >
        {event && <EventHeader event={event} margin={'0px 40px 0px 40px'} />}
        <div></div>
        <Column noBorder>
          <TextListExport listId={id} event={event} />
          <HelpModals hideModal={true} />
        </Column>
      </div>
      <Container>
        <ContainerHeader
          borderWidth={'1px'}
          style={{ position: 'relative', width: '97%' }}
        >
          <TitleContainer
            style={{
              flexDirection: 'row',
              width: '95%',
              justifyContent: 'space-between',
            }}
          >
            <FilterContainer>
              <Text
                type="heading"
                color="#3C4144"
                inlineStyle={{ marginRight: 25, whiteSpace: 'nowrap' }}
              >
                {data.getList.name || 'List Report'}
              </Text>
            </FilterContainer>
            <FilterContainer>
              <Text
                type="heading"
                as="h3"
                color="#3C4144"
                inlineStyle={{ marginRight: 20, whiteSpace: 'nowrap' }}
              >
                {`Total Recipients: ${tableData.length}`}
              </Text>
            </FilterContainer>
          </TitleContainer>
        </ContainerHeader>
        <div style={{ padding: 20 }}>
          <Table items={tableData} columns={columns} renderRows={renderRows} />
        </div>
      </Container>
    </>
  );
};

export default graphql(query, {
  options: ({ match: { params } }) => {
    const currentList = Number(params.id);
    return {
      variables: { id: currentList ? currentList : 0 },
      fetchPolicy: 'cache-and-network',
    };
  },
})(GetList);
